<div class="container-fluid common-pages-banner">
    <div class="container">
        <div class="tg-theme-heading">
            <h1 class="h1tags">Request Info</h1>
        </div>
    </div>
</div>

<div class="container-fluid paddEqual bgGray">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-12">
                <p>Get in touch with us. through email, phone or fax, or at following branch office address:</p>
            </div>
            <div class="col-md-3 col-12 mp0">
                <div class="row rowLeftM">
                    <div class="col-12 pd-0 usersformms">
                        <div class="row marginZero common-leftbar">
                            <div class="col-12">
                                <div class="col-12 usersHeader">
                                    <h4 class="card-title">Email us at:</h4>
                                </div>
                                <p>Sales/General Enquires:</p>
                                <a href="mailto:sales@propira.com ">sales@propira.com</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="row rowLeftM">
                    <div class="col-12 pd-0 usersformms">
                        <div class="row marginZero">
                            <div class="col-12">
                                <div class="col-12 usersHeader">
                                    <h4 class="card-title">Request for Information</h4>
                                </div>
                                <form class="col-12 pd-0" [formGroup]="info" [ngClass]="{'white-layer':infoLoader}" (ngSubmit)="infoEnd()" style="position: relative;">
                                    <div class="alert alert-danger alert-dismissible fade show" *ngIf="infoErrorMsg">
                                        <strong>Error!</strong> {{infoErrorMsg}}.
                                        <button type="button" style="background: none;" class="close" data-dismiss="alert">&times;</button>
                                    </div>
                                    <div class="alert alert-success alert-dismissible fade show" *ngIf="infoSuccessMsg">
                                        <strong>Success!</strong> {{infoSuccessMsg}}.
                                        <button type="button" style="background: none;" class="close" data-dismiss="alert">&times;</button>
                                    </div>
                                    <div class="form-group">
                                        <label>Name</label>
                                        <input type="text" class="form-control" required formControlName="name" placeholder="Enter Name" (keypress)="validateAlpha($event)">
                                        <div class="error-msg" *ngIf="infoControl.name.touched && infoControl.name.errors">
                                            <div style="font-size: 12px">Enter name</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Email-Id</label>
                                        <input type="email" class="form-control" required formControlName="email" placeholder="Enter Email-Id">
                                        <div class="error-msg" *ngIf="infoControl.email.touched && infoControl.email.errors">
                                            <div style="font-size: 12px">Enter valid email id</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Phone Number</label>
                                        <input type="tel" class="form-control" required formControlName="phone" placeholder="Enter Phone Number" (keypress)="numberOnly($event,10)">
                                        <div class="error-msg" *ngIf="infoControl.phone.touched && infoControl.phone.errors">
                                            <div style="font-size: 12px">Enter valid phone number</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>City</label>
                                        <input type="text" class="form-control" (keypress)="validateAlpha($event)" required formControlName="city" placeholder="Enter City">
                                        <div class="error-msg" *ngIf="infoControl.city.touched && infoControl.city.errors">
                                            <div style="font-size: 12px">Enter city name</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Pincode</label>
                                        <input type="text" class="form-control" required formControlName="pincode" placeholder="Enter Pincode" (keypress)="numberOnly($event,6)">
                                        <div class="error-msg" *ngIf="infoControl.pincode.touched && infoControl.pincode.errors">
                                            <div style="font-size: 12px">Enter valid pincode</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Query</label>
                                        <textarea class="form-control" required formControlName="query" Placeholder="Enter Query"></textarea>
                                        <div class="error-msg" *ngIf="infoControl.query.touched && infoControl.query.errors">
                                            <div style="font-size: 12px">Enter Query</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <button class="btn btn-danger" type="submit">Submit <div class="box" *ngIf="infoLoader"><div class="loader-13"></div>
                                        </div></button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>